enum AiSuggestionReview {
  NoDecision,
  Positive,
  Negative,
  AgreeWithConditions,
}

export default AiSuggestionReview
